import React, { Fragment } from 'react';
import {
  Button, Card, CardBody,
  Form, FormGroup, Input, Col, Row, Spinner, CardText
} from 'reactstrap';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import BootstrapTable from 'react-bootstrap-table-next';
import { toast } from 'react-toastify';
import { withTranslation } from 'react-i18next';

import PageTitle from '../../Layout/Components/PageTitle';
import ConfirmAction from '../../Layout/Components/ConfirmAction';

import {
  getGateways, createGateway, deleteGateway
} from '../../API/GatewayServerAPI';
import GatewayAPI from 'API/GatewayAPI';

class Gateways extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      gateways: [],
      gatewayURL: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.sync = this.sync.bind(this);
  }

  componentDidMount() {
    this.fillTable();
  }

  fillTable() {
    getGateways().then(result => {
      this.setState({
        gateways: result,
        gatewayURL: ""
      });
    }).catch(error => {
      console.error("Error getting Servers", error);
      toast["error"](this.props.t('errors.loading', { element: 'Servers', message: error.message }));
    });
  }

  handleChange(event) {
    const key = event.target.name;
    const value = event.target.value;
    this.setState({
      [key]: value
    });
  }

  add() {
    if (this.state.gatewayURL) {
      createGateway(this.state.gatewayURL).then(result => {
        toast["success"](this.props.t('messages.success_update', { element: 'gateway' }));
        this.fillTable();
      }).catch(error => {
        console.error("Error creating Servers", error);
        toast["error"](this.props.t('errors.creating', { element: 'gateway', message: error.message }));
      });
    } else {
      toast["warning"](this.props.t('messages.unable_to_create', {
        element: 'gateway',
        message: this.props.t('messages.empty_field', { field: "gateway" })
      }));
    }
  }

  delete(gatewayId) {
    deleteGateway(gatewayId).then(result => {
      toast["success"](this.props.t('messages.success_delete', { element: 'gateway' }));
      this.fillTable()
    }).catch(error => {
      console.error("Error deleting Servers", error);
      toast["error"](this.props.t('errors.deleting', { element: 'gateway', message: error.message }));
    });
  }

  sync(gatewayId) {
    GatewayAPI.synchronizeServer(gatewayId).then(result => {
      toast["success"](this.props.t('messages.success_synchonizing', { element: 'gateway' }));
      this.fillTable()
    }).catch(error => {
      console.error("Error deleting Servers", error);
      toast["error"](this.props.t('errors.synchronizing', { element: 'gateway', message: error.message }));
    });
  }

  render() {
    const { t, i18n } = this.props;

    return (
      <Fragment>
        <PageTitle
          heading={t("gateways.title")}
          icon="pe-7s-network icon-gradient bg-primary"
        />
        <CSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}>
          <Row>
            <Col md="12" lg="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <Form onSubmit={(e) => { e.preventDefault(); this.add(); }}>
                    <Row form>
                      <Col md={6}>
                        <FormGroup>
                          <Input type="text" name="gatewayURL" id="gatewayURL"
                            value={this.state.gatewayURL} onChange={this.handleChange}
                            placeholder={t("gateways.url_placeholder")} />
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <Button color="success" className="mb-2 mr-2"
                          onClick={() => this.add()}>
                          {t("gateways.actions.add")}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                  <BootstrapTable
                    bootstrap4
                    keyField="id"
                    data={this.state.gateways}
                    columns={[
                      {
                        dataField: 'url',
                        text: t("gateways.gateway")
                      },
                      {
                        dataField: 'id',
                        text: t("gateways.actions.title"),
                        isDummyField: true,
                        formatter: (cell, row, index) => {
                          return (
                            <div>
                              <div className="d-block w-100 text-center">
                                <ConfirmAction btnClassName="mb-2 mr-2" color="danger" title={t('actions.confirmation')}
                                  message={t('messages.confirm_delete', { element: 'gateway', object: row.url })}
                                  onConfirm={() => this.delete(row.id)}>{t("gateways.actions.delete")}</ConfirmAction>
                                <Button color="primary" className="mb-2 mr-2"
                                  onClick={() => this.sync(row.id)}>{t("gateways.actions.sync")}</Button>
                              </div>
                            </div>
                          );
                        }
                      }
                    ]} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </CSSTransitionGroup>
      </Fragment>
    );
  }
}

export default withTranslation()(Gateways);